import DialogContent from '@mui/material/DialogContent'
import { DataEditContextTextField } from 'Components/reusable/DataContext/fields/DataEditContextTextField'
import newWithEditModal from 'Components/reusable/HOC/newWithEditModal'
import React from 'react'
import { IUrl } from 'types/cvsInterfaces'

/**
 * Modal for adding new URL to profile.
 *
 * @returns URL modal component.
 * @notExported
 */
const LinkModal: React.FC = () => {
  return (
    <DialogContent>
      <DataEditContextTextField<IUrl> field="url" required fullWidth insetLabel />
      <DataEditContextTextField<IUrl> field="description" required multiline grow rows={12} fullWidth insetLabel />
    </DialogContent>
  )
}

export default newWithEditModal(LinkModal)
